import { Action } from "redux"
import ContextualHelpTerm = Models.ContextualHelpTerm

export interface SupportMailAddress extends Action {
    supportMailAddress: string
}

export const UPDATE_SUPPORT_MAIL_ADDRESS =
    "CONTEXTUALHELP_UPDATE_SUPPORT_MAIL_ADDRESS"

export const updateSupportMailAddress = (
    supportMailAddress: string,
): SupportMailAddress => ({
    type: UPDATE_SUPPORT_MAIL_ADDRESS,
    supportMailAddress,
})

export const INITIALIZE_DICTIONARY_VISIBLE =
    "CONTEXTUALHELP_INITIALIZE_DICTIONARY_VISIBLE"

export const initializeWithDictionaryVisible = (
    termCode: string,
): TermCodeAction => ({
    type: INITIALIZE_DICTIONARY_VISIBLE,
    termCode,
})

export interface UpdateVisibility extends Action {
    isVisible: boolean
}

export const UPDATE_TOOLTIPS_OVERLAY_VISIBILITY =
    "CONTEXTUALHELP_UPDATE_TOOLTIPS_OVERLAY_VISIBILITY"

export const updateTooltipsOverlayVisibility = (
    isVisible: boolean,
): UpdateVisibility => ({
    type: UPDATE_TOOLTIPS_OVERLAY_VISIBILITY,
    isVisible,
})

export const UPDATE_DICTIONARY_POPUP_VISIBILITY =
    "CONTEXTUALHELP_UPDATE_DICTIONARY_POPUP_VISIBILITY"

export const updateDictionaryPopupVisibility = (
    isVisible: boolean,
): UpdateVisibility => ({
    type: UPDATE_DICTIONARY_POPUP_VISIBILITY,
    isVisible,
})

export interface Filter extends Action {
    filter: string
}

export const FILTER_TERMS = "CONTEXTUALHELP_FILTER_TERMS"

export const filterTerms = (filter: string): Filter => ({
    type: FILTER_TERMS,
    filter,
})

export const LOAD_MORE_TERMS = "CONTEXTUALHELP_LOAD_MORE_TERMS"

export const loadMoreTerms = (): Action => ({
    type: LOAD_MORE_TERMS,
})

export interface SetLoading extends Action {
    isLoading: boolean
}

export const SET_DICTIONARY_LOADING = "CONTEXTUALHELP_SET_LOADING"

export const setDictionaryLoading = (isLoading: boolean): SetLoading => ({
    type: SET_DICTIONARY_LOADING,
    isLoading,
})

export interface TryTriggerTooltip extends Action {
    count: number
    termCode: string
}

export const TRY_TRIGGER_TOOLTIP = "CONTEXTUALHELP_TRY_TRIGGER_TOOLTIP"

export const tryTriggerTooltip = (
    termCode: string,
    count: number,
): TryTriggerTooltip => ({
    type: TRY_TRIGGER_TOOLTIP,
    count,
    termCode,
})

export interface TermAction extends Action {
    term: Models.ContextualHelpTerm | null
}

export const TRIGGER_TOOLTIP = "CONTEXTUALHELP_TRIGGER_TOOLTIP"

export const triggerTooltip = (
    term: Models.ContextualHelpTerm,
): TermAction => ({
    type: TRIGGER_TOOLTIP,
    term,
})

export interface TermCodeAction extends Action {
    termCode: string
}

export const SELECT_TERM_IN_DICTIONARY =
    "CONTEXTUALHELP_SELECT_TERM_IN_DICTIONARY"

export const selectTermInDictionary = (termCode: string): TermCodeAction => ({
    type: SELECT_TERM_IN_DICTIONARY,
    termCode,
})

export const SELECT_TERM_IN_TOOLTIPS = "CONTEXTUALHELP_SELECT_TERM_IN_TOOLTIPS"

export const selectTermInTooltips = (
    term: ContextualHelpTerm | null,
): TermAction => ({
    type: SELECT_TERM_IN_TOOLTIPS,
    term,
})

export const mapDispatchToProps = {
    updateSupportMailAddress,
    initializeWithDictionaryVisible,
    updateTooltipsOverlayVisibility,
    updateDictionaryPopupVisibility,
    filterTerms,
    selectTermInDictionary,
    selectTermInTooltips,
    loadMoreTerms,
    setDictionaryLoading,
}

export type DispatchProps = typeof mapDispatchToProps
